var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEmpImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ecebe8}.st1{opacity:.5;fill:#959593;enable-background:new}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h56v56H0z"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar-placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28 30.6c-4.5 0-8-6.4-8-10.6 0-4.4 3.6-8 8-8s8 3.6 8 8c0 4.2-3.5 10.6-8 10.6zm15.7 4c.2.1.3.3.3.6v4.9c0 .3-.2.6-.5.6-.8.2-1.7.5-2.6.7-3.6 1.1-8.1 2.4-13 2.4-4.8 0-9.3-1.3-12.9-2.4-.9-.3-1.7-.5-2.6-.7-.3-.1-.5-.3-.5-.6v-4.9c0-.2.1-.5.3-.6 3-1.7 6.3-2.9 9.8-3.5.3-.1.6.1.7.4 1 2.1 2.9 4.6 5.2 4.6 2.3 0 4.2-2.5 5.2-4.6.1-.3.4-.4.7-.4 3.5.6 6.8 1.8 9.9 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmpImg);
export default __webpack_public_path__ + "static/media/noEmpImg.3433e70ec2c8c8df86fd53adb66e307e.svg";
export { ForwardRef as ReactComponent };